module.exports = __webpack_public_path__ + "static/media/14.395bc52b.jpeg";